import { createSlice } from "@reduxjs/toolkit";
import { ActiveTabEnum } from "../../enums";

interface ITab {
  drawStarted: boolean;
  activeTab: ActiveTabEnum;
  isBrowserTabOrWindowInterrupt: boolean;
  spinAgainTimeout: number;
  shouldSpinWheel: boolean;
  isDrawInProgress: boolean;
}

const initialState: ITab = {
  drawStarted: false,
  isBrowserTabOrWindowInterrupt: false,
  activeTab: ActiveTabEnum.NONE,
  spinAgainTimeout: -1,
  shouldSpinWheel: false,
  isDrawInProgress: false,
};

export const tabSlice = createSlice({
  name: "tab",
  initialState,
  reducers: {
    setDrawTab: (state, { payload }) => {
      state.drawStarted = payload;
      state.isBrowserTabOrWindowInterrupt = false;
    },

    switchTab(state) {
      if (state.activeTab === ActiveTabEnum.PLAY) {
        state.activeTab = ActiveTabEnum.DRAW;
      } else {
        state.activeTab = ActiveTabEnum.PLAY;
      }
    },

    setShouldSpinWheel: (state, { payload }) => {
      state.shouldSpinWheel = payload;
    },

    setIsBrowserTabOrWindowInterrupt(state, { payload }) {
      state.isBrowserTabOrWindowInterrupt = payload;
    },

    setActiveTab(state, { payload }) {
      state.activeTab = payload;
    },

    setSpinAgainTimeout(state, { payload }) {
      state.spinAgainTimeout = payload;
    },

    setIsDrawInProgress(state, { payload }) {
      state.isDrawInProgress = payload;
    },
  },
});

export const {
  setDrawTab,
  switchTab,
  setShouldSpinWheel,
  setIsBrowserTabOrWindowInterrupt,
  setActiveTab,
  setSpinAgainTimeout,
  setIsDrawInProgress,
} = tabSlice.actions;

export default tabSlice.reducer;
